import type { TowerDesign } from "@/game/towerSpec";
import type { Section } from "@/physics/model";
/**
 * KVLY-TV MAST — Blanchard, North Dakota, 628.8 m (2,063 ft), completed 1963. A
 * triangular guyed steel mast; the tallest structure in the world until Warsaw
 * (1974), then again after Warsaw's 1991 collapse until the Burj Khalifa (2010).
 * From published data (Wikipedia): 864,500 lb (392.1 t) total; guy anchors span
 * 160 acres. Triangular cross-section; exact face width & guy schedule not
 * published → ~2.5 m face and 6 guy levels modelled (flagged). A 629 m guyed mast
 * is far beyond the sim's tuned range and will sway/collapse — accuracy to the
 * design is the goal.
 */
const MAST_LEG: Section = { name: "KVLY mast leg (tube)", A: 0.012, I: 2.5e-3, dragWidth: 0.22 };
const GUY: Section = { name: "KVLY guy strand", A: 1.4e-3, I: 2.5e-7, dragWidth: 0.045 };
const H = 628.8;
const levels: Array<[number, number]> = [
  [90, 120], [190, 230], [300, 330], [410, 400], [520, 440], [610, 470],
];
export const design: TowerDesign = {
  id: "guyed-kvly-mast",
  name: "KVLY-TV Mast (North Dakota)",
  description: "628.8 m triangular guyed mast, 1963 — world's tallest structure for decades.",
  author: "iconic tower — from published spec (Wikipedia)",
  spec: {
    type: "guyed",
    height: H,
    stack: { faces: 3, panels: 168, baseRadius: 1.44, topRadius: 1.44,
      legSection: MAST_LEG, braceSection: "angleL5", legMaterial: "a572", braceMaterial: "a572", bracing: "X" },
    guys: levels.map(([h, r]) => ({ atHeightFrac: h / H, anchorRadius: r, section: GUY, material: "guyStrand", pretensionStrain: 0.001 })),
    foundation: { soil: "stiff-clay", base: { type: "pad", width: 5, diameter: 1, depth: 4, concrete: "c20" }, anchor: { type: "deadman", width: 6, diameter: 1, depth: 4, concrete: "c20" } },
  },
};
